import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CustomTranslationLoader } from './custom-translation-loader.service';
import { TranslationInitService } from './translation-init.service';

@Injectable({
  providedIn: 'root',
})
export class TranslationHelperService {
  constructor(
    private translate: TranslateService,
    private customTranslationLoader: CustomTranslationLoader,
    private translationInitService: TranslationInitService
  ) {}

  async switchLanguage(language: string) {
    try {
      const portalSettings = JSON.parse(localStorage.getItem('portal_settings') || '{}');
      const hasAvailableLanguages = localStorage.getItem('available_languages') ? true : false;

      if (!hasAvailableLanguages) {
        console.warn('Translation switching is disabled in portal settings');
        return false;
      }

      const availableLanguages = this.getAvailableLanguages();
      if (!availableLanguages.includes(language)) {
        return false;
      }

      await this.translate.use(language).toPromise();

      localStorage.setItem('language', language);

      return true;
    } catch (error) {
      return false;
    }
  }

  async refreshAllTranslations() {
    await this.translationInitService.refreshTranslations();
  }

  getCurrentLanguage(): string {
    return this.translate.currentLang || 'en';
  }

  getAvailableLanguages(): string[] {
    return this.customTranslationLoader.getAvailableLanguages();
  }

  getLanguageNames(): { [key: string]: string } {
    return this.customTranslationLoader.getLanguageNames();
  }

  getAvailableLanguagesWithNames(): Array<{ code: string; name: string }> {
    const languages = this.getAvailableLanguages();
    const names = this.getLanguageNames();

    return languages.map((code) => ({
      code,
      name: names[code] || code.toUpperCase(),
    }));
  }

  async isLanguageAvailable(language: string): Promise<boolean> {
    const availableLanguages = this.getAvailableLanguages();

    return availableLanguages.includes(language);
  }

  areTranslationsLoaded(): boolean {
    try {
      const cacheTime = localStorage.getItem('all_translations_timestamp');
      return (
        cacheTime && Date.now() - parseInt(cacheTime) < 24 * 60 * 60 * 1000
      );
    } catch {
      return false;
    }
  }

  isTranslationEnabled(): boolean {
    try {
      const hasAvailableLanguages = localStorage.getItem('available_languages') ? true : false;

      return hasAvailableLanguages;
    } catch {
      return false;
    }
  }
}
